import { Button, Card, CardActionArea, Container, Grid, Stack, Typography } from '@mui/material';
import ArrowForwardRounded from '@mui/icons-material/ArrowForwardRounded';
import { Link as RouterLink } from 'react-router';
import { useGuides } from './api';

/** A row of guides on a home page: useful for visitors and links for search engines. */
export function GuidesSection({ title }: { title: string }) {
  const guides = useGuides().data ?? [];
  if (guides.length === 0) return null;
  return (
    <Container
      component="section"
      maxWidth="lg"
      sx={{ pb: { xs: 6, md: 8 } }}
      aria-labelledby="guias"
    >
      <Stack
        direction="row"
        sx={{ alignItems: 'flex-end', justifyContent: 'space-between', mb: 2, gap: 2 }}
      >
        <Typography id="guias" variant="h5" component="h2">
          {title}
        </Typography>
        <Button component={RouterLink} to="/guias" endIcon={<ArrowForwardRounded />}>
          Todos os guias
        </Button>
      </Stack>
      <Grid container spacing={2}>
        {guides.slice(0, 4).map((g) => (
          <Grid key={g.slug} size={{ xs: 12, sm: 6, md: 3 }}>
            <Card sx={{ height: '100%' }}>
              <CardActionArea
                component={RouterLink}
                to={`/guias/${g.slug}`}
                sx={{ p: 2.5, height: '100%', alignItems: 'flex-start' }}
              >
                <Typography variant="subtitle1" component="h3" sx={{ fontWeight: 700 }}>
                  {g.title}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ mt: 1, display: 'block' }}
                >
                  {g.readingMinutes} min de leitura
                </Typography>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
